import { Box, Button, Form, TextInput, Text, Image } from "grommet";
import React, { useEffect } from "react";

const Log = ({ log, subjects, onSelect }) => {
    const [isSubject, setIsSubject] = React.useState(false);
    const [subject, setSubject] = React.useState({} as any);

    React.useEffect(() => {
        let parts = log.split(":");

        if (parts[0] === "Subject") {
            setIsSubject(true);
            setSubject(subjects.find((s) => s.id === parts[2]));
        }
    }, [log]);

    return isSubject ? (
        <Box>
            <Box direction="row">
                <Box>
                    <Text>{subject.name}</Text>
                    <Text size="small" color={"background-front"}>
                        {subject.id}
                    </Text>
                </Box>
            </Box>
            <Box direction="row" justify="evenly">
                <Box>
                    <Text>Source Images</Text>
                    <Box direction="row" justify="between">
                        <Box direction="row" gap="small" height={"200px"} pad={"xsmall"}>
                            {subject.sourcePhotos && <Image src={subject.sourcePhotos[subject.sourcePhotos?.length - 1]} height={"150px"}></Image>}
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <Text>Share Images</Text>
                    <Box direction="row" justify="between">
                        <Box direction="row" gap="small" height={"200px"} pad={"xsmall"}>
                            {subject.sharePhotos && <Image src={subject.sharePhotos[subject.sharePhotos?.length - 1]} height={"150px"}></Image>}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Button label="View" onClick={() => onSelect(subject.id)}></Button>
        </Box>
    ) : (
        <Box direction="row">{log}</Box>
    );
};

export default Log;
